/* ------------------------------------------- */
/*   Queries for display options
/* ------------------------------------------- */

import { AppConfig } from 'AppSrc/core/config/app-config';
import {
  getRESTQuery,
} from 'AppSrc/core/queries/axios-queries';


const getDisplayOptionsQuery = (params) => {
  const {
    endpointKey,
    endpointParams,
  } = params;

  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.dispayOptions.get}/${endpointKey}`;

  return getRESTQuery(endpoint, endpointParams)
    .then((response) => {
      const results = response.data.results;

      if (results === undefined) {
        console.error(`no results found for display options endpointKey: ${endpointKey} endpointParams: ${endpointParams}`);
        return [];
      }

      return results;
    });
};

export { getDisplayOptionsQuery };
